import React from 'react';
import {EXPORT_EXCELL, EXPORT_PDF, SEARCH_FICHES} from "../../../api/Api";
import axios from 'axios';
import fileDownload from 'js-file-download';
import moment from "moment";
import FicheList from "../../../components/Modules/Fiches/FicheList";
import SearchFicheModal from "../../../components/Modals/Fiches/SearchFicheModal";
import CircularProgress from "@material-ui/core/CircularProgress";
import BootstrapLoadingButton from "../../../components/Ui/BootstrapLoadingButton";


function emptifyData(objectList){

    return objectList.map(
        (object) => {

            const newObject = {};

            for(let prop in object){

                let value = object[prop];

                if(value == 'null' || value == 'NULL' || value == undefined || value == null)
                    value = '';

                newObject[prop] = value;

            }

            return newObject;
        }
    )

}

const initialSearchValues = {
    nom: '',
    prenoms: '',
    raison_sociale: '',
    mobile: '',
    villes: [],
    communes: [],
    code: '',
    societe: '',
    natures_travaux: [],
    state: []
};

export default function FicheListPage(props){

    const [isSearchingFiche,setIsSearchingFiche] = React.useState(false);
    const [isLoadingPage,setIsLoadingPage] = React.useState(false);
    const [isExporting,setIsExporting] = React.useState(false);
    const [searchResultPagined,setSearchResultPagined] = React.useState({});
    const [formValues,setFormValues] = React.useState();
    const [searchResultPageState,setSearchResultPageState] = React.useState({currentPage:0,totalPages:0})

    const [isCreatingFiche,setIsCreatingFiche] = React.useState(false);
    const [enregistrementUnderEdition,setFicheUnderEdition] = React.useState();

    const [searchValues,setSearchValues] = React.useState(initialSearchValues);


    React.useEffect(
        () => {
            searchFiche({});
        },[]
    )

    function onFormSubmit(values){
        setFormValues(values);
        if(values != formValues)
            setSearchResultPagined({});
        searchFiche(values);
    }

    function onNewFicheClicked(){
        setIsCreatingFiche(true);
    }

    function goToFicheActif(){

    }


    function onFicheUpdated(newFiche){
        setSearchResultPagined(
            {
                ...searchResultPagined,
                [searchResultPageState.currentPage]: searchResultPagined[searchResultPageState.currentPage].map(
                    item => {
                        if(newFiche.id != item.id)
                            return item;

                        return newFiche;
                    }
                )
            }
        )
    }

    function onFicheCreated(enregistrement){
        setIsCreatingFiche(false);
        onFormSubmit({});
    }



    function onFicheUpdated(enregistrement){
        setSearchResultPagined(
            {
                ...searchResultPagined,
                [searchResultPageState.currentPage]: searchResultPagined[searchResultPageState.currentPage].map(
                    item => {
                        if(enregistrement.id != item.id)
                            return item;

                        return enregistrement;
                    }
                )
            }
        )
        setFicheUnderEdition();
    }


    async function searchFiche(values, page = 1,forceReload = false){

        console.log('formValues',values);

        if(searchResultPagined[page] && values === formValues && !forceReload){
            // console.log('reinitialisation du formulaie',page)
            setSearchResultPageState({...searchResultPageState,currentPage:page})
            return;
        }

        try{

            setIsSearchingFiche(true);

            if(page > 1)
                setIsLoadingPage(true);

            const response = (await axios.get(
                SEARCH_FICHES,
                {
                    params: {
                        ...values,
                        page: page
                    }
                }
            )).data;

            const {count,currentPage,totalPages,datas} = response;

            console.log('searchResponse',response);

            setSearchResultPagined({
                ...searchResultPagined,
                [page]: datas.map(
                    fiche => {
                        return {
                            ...fiche,
                            transmition_date: fiche.state_histories.filter(
                                state => state.new_state == 'App\\Models\\Fiches\\States\\AnalyseStep'
                            )[0]?.created_at
                        }
                    }
                )
            })

            setSearchResultPageState({
                currentPage: currentPage,
                totalPages,
                count
            })

            setIsLoadingPage(false);
            setIsSearchingFiche(true);

        } catch (e) {
            console.log(e);
        } finally {
            setIsSearchingFiche(false);
        }


    }

    async function onExportExcelClicked(){

        try{

            setIsExporting(true);

            const response = (await axios.get(
                EXPORT_EXCELL,
                {
                    responseType: 'blob',
                    params: {
                        ...formValues
                    }
                }
            ));

            fileDownload(response.data, `PGT_${moment().format('DD_MM_YYYY_hh_mm')}.xlsx`);
        } catch (e) {
            console.log(e);
        } finally {
            setIsExporting(false);
        }


    }
    
    async function onExportPDFClicked(){

        try{

            setIsExporting(true);

            const response = (await axios.get(
                EXPORT_PDF,
                {
                    responseType: 'blob',
                    params: {
                        ...formValues
                    }
                }
            ));

            fileDownload(response.data, `PGT_${moment().format('DD_MM_YYYY_hh_mm')}.pdf`);
        } catch (e) {
            console.log(e);
        } finally {
            setIsExporting(false);
        }

    }

    return (

        <div className={`card card-custom gutter-b card-stretch text-dark`}>

            <div className="card-header border-0 py-5">
                <h3 className="card-title font-weight-bolder h3 text-primary">Fiches
                    {
                        isSearchingFiche && (
                            <div className="ml-2">
                                <CircularProgress size={25} />
                            </div>
                        )
                    }
                    {
                        searchResultPageState && searchResultPageState.count != undefined && (
                            <div className="font-weight-light ml-2">
                                ({searchResultPageState.count} éntrée trouvée)
                            </div>
                        )
                    }
                </h3>
                <div className="card-toolbar">


                    <BootstrapLoadingButton isLoading={isExporting} onClick={onExportExcelClicked} className={'btn  btn-light-primary mr-2'}>
                        <i className={'flaticon2-print font-weight-bold'} />
                        Imprimer <span className="font-weight-bold">EXCEL</span>
                    </BootstrapLoadingButton>

                    <BootstrapLoadingButton isLoading={isExporting} onClick={onExportPDFClicked} className={'btn  btn-light-primary mr-2'}>
                        <i className={'flaticon2-print font-weight-bold'} />
                        Imprimer <span className="font-weight-bold">PDF</span>
                    </BootstrapLoadingButton>

                    <SearchFicheModal onSearch={(values)=>{
                        setSearchValues(values);
                        searchFiche(values,1,true)
                    }} initialValues={searchValues}>

                        <div className={'btn btn-icon btn-light-primary'}>
                            <i className={'flaticon-search'} />
                        </div>

                    </SearchFicheModal>

                    {
                        searchValues != initialSearchValues && (

                            <div
                                onClick={()=>{
                                    setSearchValues(initialSearchValues);
                                    searchFiche({},1,true)
                                }}
                                className={'btn btn-light-danger small ml-2'}>
                                Supprimer les filtres
                                <i className={'flaticon-delete'} />
                            </div>

                        )
                    }


                </div>
            </div>

            <div className={'card-body'}>

                <div className={'row'}>
                    <div className={'col-12'}>

                    </div>
                    <div className={'col-12'}>
                        <FicheList
                            onEditFiche={(enregistrement)=>{
                                setFicheUnderEdition(enregistrement)
                            }}
                            isLoadingPage={isLoadingPage}
                            onGoToPage={(page)=>{
                                searchFiche(formValues,page);
                            }}
                            onFicheUpdated={onFicheUpdated}
                            isExporting={isExporting} onExportExcelClicked={onExportExcelClicked} searchResultPageState={searchResultPageState} searchResultPagined={searchResultPagined} />
                    </div>


                </div>

            </div>

        </div>

    )
}